<app-client-log
    [clients]="clients$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async">
</app-client-log>
